import React, { useCallback } from 'react';

import { NewButton } from 'app/components/NewButton';
import { ButtonControlProps } from './ButtonControl.interfaces';

const ButtonControl = ({
  onClick,
  label = '',
  buttonOptions = { noWrap: true },
}: ButtonControlProps) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <NewButton
      onClick={handleClick}
      noWrap={buttonOptions.noWrap}
      overflowEllipsis={buttonOptions.overflowEllipsis}
      title={label}
      variant="contained"
    />
  );
};

export default ButtonControl;
